/**
 * Protokolleinträge in verständlichem Deutsch.
 *
 * Ein Protokoll, das `member.role.changed` anzeigt, liest niemand — und
 * genau das ist der Punkt eines Protokolls: dass es gelesen wird. Die
 * Schlüssel entsprechen `AuditAction` im Backend; was hier fehlt, wird roh
 * angezeigt statt verschluckt.
 */
export const AUDIT_LABELS: Record<string, string> = {
  'auth.login.success': 'Anmeldung',
  'auth.login.failure': 'Fehlgeschlagene Anmeldung',
  'auth.logout': 'Abmeldung',
  'auth.account.locked': 'Konto gesperrt (zu viele Fehlversuche)',
  'auth.registered': 'Konto angelegt',
  'auth.email.verified': 'E-Mail bestätigt',
  'auth.email.change.requested': 'Adresswechsel angefordert',
  'auth.email.change.completed': 'E-Mail-Adresse geändert',
  'auth.password.reset_requested': 'Passwort-Zurücksetzung angefordert',
  'auth.password.reset_completed': 'Passwort zurückgesetzt',
  'auth.password.changed': 'Passwort geändert',
  'auth.oauth.linked': 'Google-Konto verknüpft',

  'admin.impersonation.start': 'Sitzungsübernahme begonnen',
  'admin.impersonation.end': 'Sitzungsübernahme beendet',
  'admin.platform_access': 'Betriebsübergreifender Zugriff',
  'admin.user.locked': 'Konto gesperrt',
  'admin.user.unlocked': 'Konto entsperrt',

  'tenant.created': 'Betrieb angelegt',
  'tenant.updated': 'Betriebsstammdaten geändert',
  'tenant.settings.updated': 'Einstellungen geändert',
  'tenant.deactivated': 'Betrieb stillgelegt',

  'member.created': 'Person angelegt',
  'member.updated': 'Personalstammdaten geändert',
  'member.activation.changed': 'Stillgelegt oder reaktiviert',
  'member.account.linked': 'Zugang eingerichtet',
  'member.role.changed': 'Rolle geändert',
  'member.removed': 'Aus dem Betrieb entfernt',
  'invitation.created': 'Einladung verschickt',
  'invitation.accepted': 'Einladung angenommen',
  'invitation.revoked': 'Einladung zurückgezogen',

  'gdpr.data.exported': 'Datenauskunft erteilt',
  'gdpr.data.deleted': 'Konto gelöscht',

  // Phase 2 — Planung. Fehlten bis 2026-08-12 vollständig: Das Protokoll zeigte
  // ausgerechnet bei den Einträgen rohe Codes, für die es geführt wird.
  'shift.created': 'Schicht angelegt',
  'shift.updated': 'Schicht geändert',
  'shift.deleted': 'Schicht gelöscht',
  'assignment.created': 'Person eingeteilt',
  'assignment.removed': 'Einteilung aufgehoben',
  'assignment.override': 'Eingeteilt trotz Warnung (mit Begründung)',
  'plan.published': 'Plan veröffentlicht',
  'plan.week_copied': 'Vorwoche übernommen',
  'plan.template_applied': 'Vorlage angewendet',
  'plan.exported': 'Plan exportiert',
  'master_data.changed': 'Planungsstammdaten geändert',
  'absence.decided': 'Abwesenheit entschieden',
  'leave.entitlement.set': 'Urlaubsanspruch gesetzt',

  // Phase 3 — Selfservice
  'absence.requested': 'Abwesenheit beantragt',
  'availability.changed': 'Verfügbarkeit geändert',
  'swap.offered': 'Schicht zum Tausch angeboten',
  'swap.claimed': 'Tausch übernommen',
  'swap.withdrawn': 'Tauschangebot zurückgezogen',
  'swap.decided': 'Tausch entschieden',
  'shift.applied': 'Auf Schicht beworben',
  'shift.application.decided': 'Bewerbung entschieden',
  'revenue.recorded': 'Tagesumsatz erfasst',
  'calendar.token.issued': 'Kalender-Abo erstellt',
  'calendar.token.revoked': 'Kalender-Abo widerrufen',
}
